import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { NestAuthProvider } from '../../shared/nestjs/nest-auth';

@Injectable()
export class SyncBloc {

    private basePath = 'https://api.greatdayhr.com/gd-signin-dev';

    constructor(
        private http: HttpClient,
        private nestAuthProvider: NestAuthProvider,
        private nestApiProvider: NestApiProvider,
    ) {

    }

    /**
     * List Data Email
     */
    private searchEmail(username: string): Observable<any> {
        return this.http.get(`${this.basePath}/sync/search?username=${username}`)
            .timeout(10000);
    }

    /**
     * Register
     */
    private registerEmail(): Observable<any> {
        const headers = new HttpHeaders()
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('baseurl', this.nestApiProvider.gopathNew);
        return this.http.post(`${this.basePath}/sync/register`, {}, { headers }).timeout(10000);
    }

    /**
     * List Data Email
     */
    private listEmail(): Observable<any> {
        const headers = new HttpHeaders()
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('baseurl', this.nestApiProvider.gopathNew);
        return this.http.get(`${this.basePath}/sync/lists`, { headers })
            .timeout(10000);
    }

    async getListCompany(email: string) {
        try {
            const data = await this.searchEmail(email).toPromise();
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    async getListEmail() {
        try {
            const data = await this.listEmail().toPromise();
            return data.data;
        } catch (error) {
            throw error;
        }
    }

    async setEmail() {
        try {
            const data = await this.registerEmail().toPromise();
            return data.message;
        } catch (error) {
            throw error;
        }
    }

}



// WEBPACK FOOTER //
// ./src/bloc/authentication/sync.bloc.ts